import { SCREENS, REDUX_ACTIONS, GAME_ID } from 'a/bookClub/data/constants';

const initState = {
  currentScreen: SCREENS.LOADING,
};

const screenReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.START_ROUND:
      return {
        currentScreen: SCREENS.CHARACTER_INTRO,
      };
    case REDUX_ACTIONS.RETURN_TO_PROGRESS_SCREEN:
    case REDUX_ACTIONS.END_ROUND: {
      return {
        currentScreen: SCREENS.PROGRESS,
      };
    }
    case REDUX_ACTIONS.COMPLETE_ITEMS: {
      if (payload.returnAfterOnboarding) {
        return {
          currentScreen: SCREENS.PROGRESS,
        };
      }
      return {
        currentScreen: SCREENS.CHARACTER_INTRO,
      };
    }
    case REDUX_ACTIONS.REPEAT_ONBOARDING:
    case REDUX_ACTIONS.CONTINUE_TO_STANDARD:
      return {
        currentScreen: SCREENS.STANDARD,
      };

    default:
      return state;
  }
};

export default screenReducer;
